import { Autocomplete, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { api } from '../../api';
import { Department } from '../../schema/person';

interface DepartmentFromInputProps {
  required?: boolean;
  value?: number | null;
  onChange?: (value: number | null) => void;
}

const DepartmentFromInput: React.FC<DepartmentFromInputProps> = ({
  required,
  value,
  onChange
}: DepartmentFromInputProps) => {
  const [searchKeyword, setSearchKeyword] = useState<string>('');
  const [departmentList, setDepartmentList] = useState<Department[]>([]);
  const [selectedValue, setSelectedValue] = useState<Department | null>(null);

  useEffect(() => {
    if (value != null) {
      const department = departmentList.find((data) => data.id == value);
      if (department) {
        setSelectedValue(department);
        return;
      }
      api.get<Department>(`/department/${value}`).then((res) => {
        const { data } = res;
        setSelectedValue(data);
        setDepartmentList([data]);
      });
    } else {
      api.get<Department[]>(`/department`).then((res) => {
        const { data } = res;
        setDepartmentList(data);
      });

      setSelectedValue(null);
    }
  }, [value]);

  useEffect(() => {
    if (searchKeyword) {
      const timeOut = setTimeout(() => {
        const searchParams = new URLSearchParams();
        searchParams.set('name', searchKeyword);
        // searchParams.set('limit', '10');

        api.get<Department[]>(`/department`, { params: searchParams }).then((res) => {
          const { data } = res;
          setDepartmentList(data);
        });
      }, 500);
      return () => clearTimeout(timeOut);
    }
  }, [searchKeyword]);
  return (
    <Autocomplete
      options={departmentList}
      getOptionLabel={(option) => (option?.department_name ? option.department_name : '')}
      renderInput={(params) => (
        <TextField {...params} label="หน่วยงาน" required={required} placeholder="หน่วยงาน" />
      )}
      onChange={(_, value) => onChange && onChange(value ? value.id : null)}
      value={selectedValue}
      onInputChange={(_, newInputValue) => {
        setSearchKeyword(newInputValue);
      }}
      isOptionEqualToValue={(option, v) => v?.id == option?.id}
      fullWidth
    />
  );
};

export default DepartmentFromInput;
